/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from "@tanstack/react-query";
import { myHeaders } from "../../config/axios";
import { useState } from "react";
import Swal, { SweetAlertOptions } from "sweetalert2";
import { URL_API } from "../../config/default";
import { CustomToast } from "../../utils/custom-toast";

const Informacion = () => {
  const [form, setForm] = useState<any>({
    firstname: "",
    lastname: "",
    phone: "",
    address: "",
    image: ""
  });
  const { isPending, error, data } = useQuery({
    queryKey: ["me"],
    queryFn: () => {
      const authorization = new Headers();
      authorization.append("Authorization", myHeaders);
      return fetch(`${URL_API}/auth/me`, {
        method: "GET", // O 'POST', 'PUT', 'DELETE', etc. dependiendo de tu solicitud
        headers: {
          Authorization: myHeaders, // Un ejemplo de header de autenticación
        },
      }).then((res) => res.json());
    },
  });

  if (isPending) return "Loading...";

  if (error) return "Error...";

  const submit = async (formdata: any) => {
    const requestOptions = {
      method: "PUT",
      body: formdata,
      headers: {
        Authorization: myHeaders, // Un ejemplo de header de autenticación
      },
    };

    fetch(`${URL_API}/auth/me`, requestOptions)
      .then(() => {
        const Toast = Swal.mixin({
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
          didOpen: (toast) => {
            toast.onmouseenter = Swal.stopTimer;
            toast.onmouseleave = Swal.resumeTimer;
          },
        } as SweetAlertOptions);

        return Toast.fire({
          icon: "success",
          title: "Updated in successfully",
        });
      })
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
  };

  const upload = async (e: any) => {
    const formdata = new FormData();

    for (let index = 0; index < e.target.files.length; index++) {
      formdata.append("file[" + index + "]", e.target.files[index]);
    }

    const requestOptions = {
      method: "POST",
      body: formdata,
      headers: {
        Authorization: myHeaders, // Un ejemplo de header de autenticación
      },
    };

    fetch(`${URL_API}/auth/upload`, requestOptions)
      .then(async () => {
        CustomToast({
          status: 200,
          msg: "",
          title: "Imagene cargada",
        });
      })
      .then((result) => console.log(result))
      .catch((error) => console.error(error));
  };

  const user = data.data;

  return (
    <div className="bg-white rounded-lg shadow-sm border m-auto md:w-[80%] py-4 px-4 ">
      <div className="grid grid-cols-1 gap-2">
        <div className="py-4">
          <span className="text-primary font-bold text-xl mb-4 block">
            Informacion personal
          </span>

          <div className="mb-4">
            <div className="grid grid-cols-1 gap-5">
              <span>
                Selecciona una foto de perfil.
              </span>

              <label className="border-dashed px-5 py-5 border border-black items-center"
              style={{
                width: '100%',
                height: '300px',
                backgroundImage: `url(${user.image})`,
                backgroundSize: 'contain',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat'
              }}>
                <img src={form.image} alt="" className="mx-auto" width={200} />
                <div className="text-center my-4">
                  <span className="block font-bold">
                    Seleccioná al menos una foto de perfil
                  </span>
                  <span className="border border-black border-s-0 border-t-0 border-e-0">
                    Subilas desde tu dispositivo
                  </span>
                </div>
                <input
                  className="hidden"
                  type="file"
                  name="images"
                  accept="image/*"
                  onChange={(e) => upload(e)}
                />
              </label>
            </div>
          </div>
          <div className="mb-4">
            <div className="w-full flex justify-between mb-2">
              <span className="block font-bold">Nombre legal</span>
            </div>
            <input
              type="text"
              id="form-firstname-lastname"
              className="border-0 rounded-md w-full"
              defaultValue={`${user.firstname} ${user.lastname}`}
              onChange={(e) => {
                const firstname =
                  e.target.value.split(" ").length !== 0
                    ? e.target.value.split(" ")[0]
                    : "";
                const lastname =
                  e.target.value.split(" ").length > 1
                    ? e.target.value.split(" ")[1]
                    : "";
                setForm({
                  ...form,
                  firstname: firstname,
                  lastname: lastname,
                });
              }}
            />
          </div>

          <div className="flex justify-between mb-4">
            <div>
              <span className="block font-bold">Correo electronico</span>
              <span className="block px-2">{`${user.email}`}</span>
            </div>

            <label className="font-bold">
              <button className="hidden"></button>
            </label>
          </div>

          <div className="flex justify-between mb-4">
            <div className="w-full">
              <span className="block font-bold">Número de telefono</span>
              <input
                type="text"
                id="form-phone"
                className="border-0 rounded-md w-full"
                defaultValue={`${user.phone}`}
                onChange={(e) => {
                  setForm({
                    ...form,
                    phone: e.target.value,
                  });
                }}
              />
              <span className="block">
                Agregá un número para que los huéspedes con reservas confirmadas
                pueden comunicarse con vos.
              </span>
            </div>
          </div>

          <div className="flex justify-between mb-4">
            <div className="w-full">
              <span className="block font-bold">Dirección</span>
              <input
                type="text"
                id="form-address"
                className="border-0 rounded-md w-full"
                defaultValue={`${user.address}`}
                onChange={(e) => {
                  setForm({
                    ...form,
                    address: e.target.value,
                  });
                }}
              />
            </div>
          </div>

          <div className="flex justify-end w-full">
            <label className="cursor-pointer flex justify-center bg-[#8B9456] text-white px-4 py-2 rounded-xl hover:opacity-[0.9] transition duration-500 me-2 font-semibold  w-[200px]">
              <div id="label-firstname-lastname">Editar</div>
              <button
                className="hidden"
                onClick={() => {
                  if (
                    document
                      .getElementById("form-firstname-lastname")
                      ?.classList.contains("border-0")
                  ) {
                    document
                      .getElementById("form-firstname-lastname")
                      ?.classList.remove("border-0");
                    document
                      .getElementById("form-address")
                      ?.classList.remove("border-0");
                    document
                      .getElementById("form-phone")
                      ?.classList.remove("border-0");

                    document.getElementById(
                      "label-firstname-lastname"
                    )!.innerHTML = "Guardar";
                  } else {
                    document
                      .getElementById("form-address")
                      ?.classList.add("border-0");
                    document
                      .getElementById("form-firstname-lastname")
                      ?.classList.add("border-0");
                    document
                      .getElementById("form-phone")
                      ?.classList.add("border-0");

                    document.getElementById(
                      "label-firstname-lastname"
                    )!.innerHTML = "Editar";

                    const formData = new FormData();
                    formData.append("_method", "PUT");
                    if (form.firstname !== "")
                      formData.append("firstname", form.firstname);
                    if (form.lastname !== "")
                      formData.append("lastname", form.lastname);
                    if (form.address !== "")
                      formData.append("address", form.address);
                    if (form.phone !== "") formData.append("phone", form.phone);

                    submit(formData);
                  }
                }}
              ></button>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Informacion;
